<template>
  <div class="table-responsive">
    <table
      class="table table-striped table-sm table-bordered"
      :id="dataTable.id"
    >
      <thead>
        <tr>
          <th class="text-center">#</th>
          <th>Nome</th>
          <th>URL</th>
          <th>Empresas</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="report in reports" :key="report.id">
          <td class="text-center">{{ report.hash }}</td>
          <td>{{ report.nome }}</td>
          <td>{{ report.url }}</td>
          <td>
            <p v-for="company in report.companies" :key="company.id">
              {{ company.empresaCnpj }} - {{ company.empresaNome }}
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import '@/utils/basicDataTableExtend'

export default {
  name: 'ListReports',

  props: {
    reports: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      table: null,
      dataTable: {
        id: 'dataTableListReports',
        order: [[1, 'asc']],
        columnDefs: [
          {
            targets: [1],
            width: 250,
          },
          {
            targets: [2],
            width: 300,
          },
          {
            targets: [3],
            width: 300,
          },
        ],
      },
    }
  },

  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }
      this.table = window.$(`#${this.dataTable.id}`).DataTable({
        order: this.dataTable.order,
        columnDefs: this.dataTable.columnDefs,
      })
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
